 


  const RecordStatusEnum = {
    ACTIVE: "Active",
    IN_ACTIVE: "InActive",
    DELETED: "Deleted",
  };

  const UserRolesEnum = {
    SUPER_ADMIN: "superAdmin",
    ADMIN: "admin",
    SUPERVISOR: "supervisor",
    TECHINICIAN: "technician",
  };

  const UserRolesEnumLabels = {
    [UserRolesEnum.SUPER_ADMIN]: "Super Admin",
    [UserRolesEnum.ADMIN]: "Admin",
    [UserRolesEnum.SUPERVISOR]: "Supervisor",
    [UserRolesEnum.TECHINICIAN]: "Technician",
  };

  const PriorityEnum = {
    URGENT:"urgent",
    HIGH: "high",
    MEDIUM: "medium",
    LOW: "low",
  };
  
const PriorityEnumLabels = {
    [PriorityEnum.URGENT]: "Urgent",
    [PriorityEnum.HIGH]: "High",
    [PriorityEnum.MEDIUM]: "Medium",
    [PriorityEnum.LOW]: "Low",
  };

  const ReferralSourceEnum = {
    EMPLOYEE:"Employee",
    CUSTOMER: "Customer",
    OPEN: "Open"
  };
  
const ReferralSourceEnumLabels = {
    [ReferralSourceEnum.EMPLOYEE]: "Employee",
    [ReferralSourceEnum.CUSTOMER]: "Customer",
    [ReferralSourceEnum.OPEN]: "Open",
  };

  const JobTypeEnum = {
    FULLTIME:"FullTime",
    PARTTIME: "PartTime",
    CONTRACT: "Contract",
    INTERSHIP: "Intership",
    SUBCONTRACT: "SubContract",
  };
  
const JobTypeEnumLabels = {
    [JobTypeEnum.FULLTIME]: "Full Time",
    [JobTypeEnum.PARTTIME]: "Part Time",
    [JobTypeEnum.CONTRACT]: "Contract",
    [JobTypeEnum.INTERSHIP]: "Intership",
    [JobTypeEnum.SUBCONTRACT]: "Sub-Contract",
  };

  const EmploymentStatusEnum = {
    INNOTICEPERIOD: "innoticeperiod",
    READYTOJOIN: "readytojoin",
    NOTINNOTICEPERIOD: "notinnoticeperiod"    
  };

  const EmploymentStatusEnumLabels = {
    [EmploymentStatusEnum.INNOTICEPERIOD]: "In Notice Period",
    [EmploymentStatusEnum.READYTOJOIN]: "Ready to Join",
    [EmploymentStatusEnum.NOTINNOTICEPERIOD]: "Not in Notice Period"
  };
  const JobDetailStatusEnum={
    WAITINGFORAPPROVAL:"waitingforapproval",
    OPEN:"open",
    ONHOLD:"onhold",
    CLOSED:"closed"
  };
  const JobDetailStatusEnumLabels={
    [JobDetailStatusEnum.WAITINGFORAPPROVAL]: "Waiting For Approval",
    [JobDetailStatusEnum.OPEN]: "Open",
    [JobDetailStatusEnum.ONHOLD]: "On Hold",
    [JobDetailStatusEnum.CLOSED]: "Closed"
  };
  const WorkModeEnum = {
    REMOTE:"remote",
    HYBRID: "hybrid",
    OFFICE: "office",
  };
  const PayTypeEnum = {
    HOURLY:"Hourly",
    MONTHLY: "Monthly",
    YEARLY: "Yearly",
  };  
  const PayTypeEnumLabels = {
    [PayTypeEnum.HOURLY]: "Hourly",
    [PayTypeEnum.MONTHLY]: "Monthly",
    [PayTypeEnum.YEARLY]: "Yearly",
  };
  
const WorkModeEnumLabels = {
    [WorkModeEnum.REMOTE]: "Remote",
    [WorkModeEnum.HYBRID]: "Hybrid",
    [WorkModeEnum.OFFICE]: "Office",
  };
  const FunctionalityNames = {
    DASHBOARD:"Dashboard",
    JOBLIST: "JobList",
    YEARLY: "JobPost",
    BOARD:"Board",
    MAPPING:"Mapping",
    CANDIDATE:"Candidate",
    USERS:"Users",
    SETTINGS:"Settings",
    REPORT:"Report"
  }; 
  module.exports = {   
    
    RecordStatusEnum,
    UserRolesEnum,
    UserRolesEnumLabels,
    PriorityEnum,
    PriorityEnumLabels,
    ReferralSourceEnum,
    ReferralSourceEnumLabels,
    JobTypeEnum,
    JobTypeEnumLabels,
    EmploymentStatusEnum,
    EmploymentStatusEnumLabels,
    JobDetailStatusEnum,
    JobDetailStatusEnumLabels,
    WorkModeEnum,
    WorkModeEnumLabels,
    PayTypeEnum,
    PayTypeEnumLabels,
    FunctionalityNames
  };